import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { environment } from '@env/environment';

import { StringUtils } from '@shared/utils/stringUtils';

@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss'],
  standalone: true,
  imports: [RouterLink]
})
export class BrandingComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private _router: Router
  ) {}

  protected brandLogoPath = StringUtils.brandResource('logo');
  protected brandLogo: string | undefined;
  protected brandLogoPathLight = StringUtils.brandResource('logoLight');
  protected brandLogoWidth = environment.logoWidthPx ?? '160px';
  private observer: MutationObserver | undefined;

  get isDarkMode(): boolean {
    return this.document.documentElement.classList.contains('theme-dark');
  }

  ngOnInit(): void {
    this.updateLogo();

    // Watch for changes to the HTML element's class attribute
    this.observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          this.updateLogo();
        }
      });
    });

    this.observer.observe(this.document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private updateLogo(): void {
    this.brandLogo = this.isDarkMode ? this.brandLogoPath : this.brandLogoPathLight;
  }

  /**
   * Handles logo click - behaves like the "New" button in navigation
   * If on dashboard, reloads page and clears sources. Otherwise navigates to dashboard.
   */
  onLogoClick(event: Event): void {
    event.preventDefault();
    if (this._router.url === '/dashboard') {
      // If already on dashboard, refresh the page
      window.location.reload();
      localStorage.setItem('bot_sources_global', JSON.stringify([]));
    } else {
      // If on another page, navigate to dashboard
      this._router.navigate(['/dashboard']);
    }
  }
}
